import {
  faArrowDownShortWide,
  faArrowUpShortWide,
} from "@awesome.me/kit-c1b85ff10f/icons/classic/light";
import { useAppContext } from "../../../AppProvider";
import { faMoneyBillTransfer } from "../../../utilities/fontawesomeIcons";
import { useIndexCodCollectionsContext } from "../providers/Index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTypes } from "../../../utilities/types";

export const isDisabledLiquidateLabels = (selectedRows) => {
  const { accessTokenPayload } = useAppContext();
  return !selectedRows.every(
    (item) => item.collectionDate && item.ownerId === accessTokenPayload.owner
  );
};

export const useListProps = () => {
  const { dictionary } = useAppContext();
  const { setModalConfig } = useIndexCodCollectionsContext();

  const { confirmationOptions } = useTypes();

  return {
    path: "/shipment-service/cod-collections",
    sorting: [
      {
        orderBy: "desc",
        column: "collectionDate",
        icon: faArrowDownShortWide,
        label: dictionary.dates.collected_date,
        isDefault: true,
      },
      {
        orderBy: "asc",
        column: "collectionDate",
        icon: faArrowUpShortWide,
        label: dictionary.dates.collected_date,
        isDefault: false,
      },
    ],
    banner: {
      enabled: false,
    },
    title: dictionary.cod_collections.my_cod_collections,
    omnisearch: {
      enabled: true,
      placeholder: dictionary.references.references,
    },
    filters: {
      name: "cod_collections",
      preserve: false,
      list: [
        {
          fieldName: "collectionDate",
          label: dictionary.status.collected_sm,
          type: "select",
          options: confirmationOptions,
          primary: true,
          col: 2,
        },
      ],
    },
    massiveActions: [
      {
        onClick: (selectedRows) =>
          setModalConfig({
            isOpen: true,
            title: dictionary.cod_returns.liquidate_labels,
            action: "codLiquidation",
            data: selectedRows.map((r) => r.id),
          }),
        isDisabled: isDisabledLiquidateLabels,
        label: dictionary.cod_returns.liquidate_labels,
        icon: <FontAwesomeIcon icon={faMoneyBillTransfer} />,
        className: "button-1 button-1-transparent",
      },
    ],
  };
};
